module.exports = __webpack_public_path__ + "static/media/image-5.ff5d94f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-54/image-5.jpg
// module id = 273
// module chunks = 0